<template>
    <ul>
        <li> <router-link to="/help/novel/book">小説を追加する</router-link> </li>
        <li> <router-link to="/help/novel/sections">本文を管理する</router-link> </li>
        <li> <router-link to="/help/novel/episode">本文を執筆する</router-link> </li>
        <li> <router-link to="/help/novel/regulation">本文の規約</router-link> </li>
        <li> <router-link to="/help/novel/versions">小説の版を管理する</router-link> </li>
        <li> <router-link to="/help/novel/notes">ノートを記述する</router-link> </li>
        <li> <router-link to="/help/novel/publish">公開日の設定</router-link> </li>
        <li> <router-link to="/help/novel/pickup">ピックアップ</router-link> </li>
        <li> <router-link to="/help/novel/outlines">あらすじを書く</router-link> </li>
        <li> <router-link to="/help/novel/applause">拍手ボタンを設置する</router-link> </li>
        <li> <router-link to="/help/novel/genre">ジャンルにまとめる</router-link> </li>
        <li> <router-link to="/help/novel/series">シリーズにまとめる</router-link> </li>
        <li> <router-link to="/help/novel/sort">順番を変更する</router-link> </li>
        <li> <router-link to="/help/novel/backup">バックアップする</router-link> </li>
        <li> <router-link to="/help/novel/advertise">宣伝する</router-link> </li>
        <li> <router-link to="/help/novel/planner">プロットと執筆実績</router-link> </li>
    </ul>
</template>
